import { PageFilter } from '@gettactic/api';
import { useTacticHooks } from '@gettactic/hooks';
import { useQuery } from '@tanstack/react-query';

export const usePagesQuery = (filters?: PageFilter) => {
  const { apiClient } = useTacticHooks();
  return useQuery(
    ['usePagesQuery', apiClient.slug, filters],
    async () => {
      const res = await apiClient.pages.getPages(filters);
      return res.result;
    },
    {
      enabled: !!apiClient.slug
    }
  );
};
